export default __webpack_public_path__ + "56f6a7a74f6536ef84df1f5455c49567.png";